import React from 'react';
import {
  BondInsuranceAnalysisForGetCompleteBondInsuranceProposalByIdResponseDTO,
  BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO
} from '../../../../../dtos/bond-insurance-proposal-list/get-complete-bond-insurance-proposal-by-id-response.dto';
import { DateToStringDate } from '../../../../../services/date';
import { PurposesEnum } from '../../../../../enums/purposes.enum';
import { AnalysisAssuranceEnum } from '../../../../../enums/analysis-assurance.enum';
import { PersonTypesEnum } from '../../../../../enums/person-types.enum';

export type Props = {
  bondInsurance: BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO;
  bondInsuranceAnalysis: BondInsuranceAnalysisForGetCompleteBondInsuranceProposalByIdResponseDTO;
};

const FieldDisplay = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div style={{ paddingBottom: '16px' }}>
    <div
      style={{
        fontWeight: 'bold',
        marginBottom: '0.35em',
        color: '#555',
        fontSize: '0.85em',
        textTransform: 'uppercase'
      }}
    >
      {label}
    </div>
    <div style={{ fontSize: '0.95em', wordBreak: 'break-word' }}>
      {value || 'Indisponível'}
    </div>
  </div>
);

export const BondInsuranceMainInfoDetails = (props: Props) => {
  const { bondInsurance, bondInsuranceAnalysis } = props;
  const { property } = bondInsurance;

  return (
    <div className="row" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="ID" value={bondInsurance.id} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}></div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="DATA DA ANÁLISE"
            value={DateToStringDate(bondInsurance.createdAt)}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="CRIADA POR" value={bondInsurance.user.name} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="CORRETORA" value={bondInsurance.broker?.name || ''} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="IMOBILIÁRIA" value={bondInsurance.estate?.name} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="FINALIDADE"
            value={
              bondInsurance.purpose === PurposesEnum.commercial
                ? 'Comercial'
                : 'Residencial'
            }
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="TIPO DE LOCATÁRIO"
            value={
              bondInsurance.tenantType === PersonTypesEnum.legal
                ? 'Pessoa Jurídica'
                : 'Pessoa Física'
            }
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="MOTIVO DA LOCAÇÃO" value={property.reason} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="GESTOR DE CONTAS" value={bondInsurance.user.name} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="GARANTIA DA ANÁLISE"
            value={
              (() => {
                return (
                  bondInsuranceAnalysis.analysisAssurance ??
                  bondInsurance.analysisAssurance
                );
              })() === AnalysisAssuranceEnum.complete
                ? 'Completa'
                : 'Simples'
            }
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="VIGÊNCIA DO CONTRATO"
            value={`${property.validity} MESES`}
          />
        </div>
      </div>

      {property.location_in_progress && (
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
            <FieldDisplay
              label="CONTRATO DE LOCAÇÃO VIGENTE"
              value={`${property.location_in_progress ? 'SIM' : 'NÃO'}`}
            />
          </div>
          <div style={{ flex: 1, boxSizing: 'border-box' }}></div>
        </div>
      )}
    </div>
  );
};
